import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    content: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(1)
    },
    root: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: 'url(/images/auth.jpg)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    }
}));

const Logout = ({ history }) => {
    const classes = useStyles();
    useEffect(() => {
        const timer = setTimeout(() => {
            history.push('/sign-in');
        }, 1000);

        return () => clearTimeout(timer);
    }, [history]);

    return (
        <div className={classes.root}>
            <Dialog open>
                <DialogContent className={classes.content}>
                    <CircularProgress />
                    <Typography align="center">
                        Veuillez patienter pendant la déconnexion...
                    </Typography>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Logout;
